/**
 * Returns a new object, equivalent to the input, with keys sorted in number-alphabetical order
 *
 * @param obj - The object to sort.
 * @returns The sorted object.
 *
 * @example
 * sortByKeys({ b: 2, a: 1, c: 3 }) // { a: 1, b: 2, c: 3 }
 * sortByKeys({ 1: 'a', 2: 'b', 3: 'c' }) // { 1: 'a', 2: 'b', 3: 'c' }
 * sortByKeys({ 2: 'b', 1: 'a', 3: 'c' }) // { 1: 'a', 2: 'b', 3: 'c' }
 * sortByKeys({ c: 'c', 1:1, b:'b', 3:3, 2:2, a:'a'  }) // { 1:1, 2:2, 3:3, a:'a', b:'b', c: 'c' }

 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function sortByKeys<T extends Record<string, any>>(
  obj: T | undefined | null,
): T {
  if (!obj || typeof obj !== 'object') {
    return {} as T
  }

  if (Array.isArray(obj)) {
    return obj
  }

  const sortedKeys = Object.keys(obj).sort()

  const sorted: T = {} as T

  for (const key of sortedKeys) {
    sorted[key as keyof T] = obj[key]
  }

  return sorted
}
